import axios from '@/lib/axios';

const getAll = async (params = {}) => {
    // params can include { type, categoryId, search, page, limit }
    const response = await axios.get('/transactions', { params });
    return response.data;
};

const create = async (data) => {
    const response = await axios.post('/transactions', data);
    return response.data;
};

const update = async (id, data) => {
    const response = await axios.put(`/transactions/${id}`, data);
    return response.data;
};

const remove = async (id) => {
    const response = await axios.delete(`/transactions/${id}`);
    return response.data;
};

const exportCsv = async () => {
    const response = await axios.get('/transactions/export', {
        responseType: 'blob',
    });
    return response.data;
};

const transactionService = {
    getAll,
    create,
    update,
    remove,
    exportCsv,
};

export default transactionService;
